import React, { FC } from 'react'
import { CheckWithElement } from 'Pages/landings/newLandings/common/components'
import { ListWithImgComponent } from 'Pages/landings/newLandings/selfEmployed/common/components/ListWithImg'
import toolsWebp from './tools.webp'
import toolsJpg from './tools.jpg'
import { Text } from './styled'

export const ToolsComponent: FC = () => (
	<ListWithImgComponent
		imgWebp={toolsWebp}
		imgJpg={toolsJpg}
		isReverse
		title="Инструменты для&nbsp;решения задач за&nbsp;0 ₽"
		subtitle="Услуги и сервисы доступны после&nbsp;подключения сервиса «Своё дело»"
	>
		<CheckWithElement
			text={() => <Text> Консультация с юристом по&nbsp;рабочему или&nbsp;частному вопросу</Text>}
		/>
		<CheckWithElement text={() => <Text> Конструктор документов: договоры, акты, счета</Text>} />
		<CheckWithElement text={() => <Text>Сервис для онлайн-записи и учёта клиентов</Text>} />
	</ListWithImgComponent>
)
